import { render, staticRenderFns } from "./ForgotPasswordAction.vue?vue&type=template&id=7eb80abc&scoped=true"
import script from "./ForgotPasswordAction.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordAction.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordAction.vue?vue&type=style&index=0&id=7eb80abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb80abc",
  null
  
)

export default component.exports